import { render, staticRenderFns } from "./MemoRow.vue?vue&type=template&id=0e303970&scoped=true"
import script from "./MemoRow.vue?vue&type=script&lang=ts"
export * from "./MemoRow.vue?vue&type=script&lang=ts"
import style0 from "./MemoRow.vue?vue&type=style&index=0&id=0e303970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e303970",
  null
  
)

export default component.exports